// extracted by mini-css-extract-plugin
module.exports = {"animatedLogoWrapper":"styles_animatedLogoWrapper__jMezq","videoPlayer":"styles_videoPlayer__u0vRF"};